import { styled } from "@puzzle/theme";
/**
 * @deprecated use packages/app/ve/Box/Box.tsx instead
 */
export const Box = styled("div");
